/**
 * Composable per gestire i dropdown globalmente
 * Risolve il problema dei dropdown multipli aperti nei componenti ricorsivi
 */

import { ref } from 'vue';

// Stato globale condiviso tra tutti i componenti
const activeDropdownId = ref(null);
const dropdownRegistry = new Map();

export function useDropdownManager() {
	/**
	 * Registra un dropdown e restituisce un ID univoco
	 */
	function registerDropdown(closeCallback) {
		const id = `dropdown-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
		dropdownRegistry.set(id, closeCallback);
		return id;
	}

	/**
	 * Rimuove un dropdown dal registro
	 */
	function unregisterDropdown(id) {
		dropdownRegistry.delete(id);
		if (activeDropdownId.value === id) {
			activeDropdownId.value = null;
		}
	}

	/**
	 * Apre un dropdown e chiude tutti gli altri
	 */
	function openDropdown(id) {
		// Chiudi il dropdown precedentemente attivo
		if (activeDropdownId.value && activeDropdownId.value !== id) {
			const closeCallback = dropdownRegistry.get(activeDropdownId.value);
			if (closeCallback) {
				closeCallback();
			}
		}
		activeDropdownId.value = id;
	}

	/**
	 * Chiude un dropdown specifico
	 */
	function closeDropdown(id) {
		if (activeDropdownId.value === id) {
			activeDropdownId.value = null;
		}
	}

	/**
	 * Verifica se un dropdown è attivo
	 */
	function isActive(id) {
		return activeDropdownId.value === id;
	}

	return {
		registerDropdown,
		unregisterDropdown,
		openDropdown,
		closeDropdown,
		isActive,
	};
}
